import makeMountAutoComplete from './make-mount-auto-complete'
import setupCompanyAutoComplete from './company-auto-complete'
import setupGroupAutoComplete from './group-auto-complete'
import setupUnassignedUsersAutoComplete from './unassigned-users-for-group-auto-complete'
import setupUnassignedCompaniesAutoComplete from './unassigned-companies-for-group-auto-complete'

export default ({ onDomLoad, typeahead }) => {
  const mountAutoComplete = makeMountAutoComplete({
    onDomLoad,
    typeahead,
  })

  const teardownCompanyAutoComplete =
    setupCompanyAutoComplete(mountAutoComplete)
  const teardownGroupAutoComplete = setupGroupAutoComplete(mountAutoComplete)
  const teardownUnassignedUsersAutoComplete =
    setupUnassignedUsersAutoComplete(mountAutoComplete)
  const teardownUnassignedCompaniesAutoComplete =
    setupUnassignedCompaniesAutoComplete(mountAutoComplete)

  return () => {
    teardownCompanyAutoComplete()
    teardownGroupAutoComplete()
    teardownUnassignedUsersAutoComplete()
    teardownUnassignedCompaniesAutoComplete()
  }
}
